import { render, staticRenderFns } from "./DomainPicker.vue?vue&type=template&id=42b3e8ec&scoped=true"
import script from "./DomainPicker.vue?vue&type=script&lang=js"
export * from "./DomainPicker.vue?vue&type=script&lang=js"
import style0 from "./DomainPicker.vue?vue&type=style&index=0&id=42b3e8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3e8ec",
  null
  
)

export default component.exports